document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var drawer = document.querySelector('[data-mobile-drawer]');
      if (!drawer) return;
      var open = drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var input = button.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var next = Number(input.value || 1) + (button.hasAttribute('data-quantity-plus') ? 1 : -1);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});